import { NotificationRegistry } from '@neos/core'
import RealTimeDecEvent from '@src/dataObjects/RealTimeDecEvent'

/**
 * Represents Notifications.
 */
export default class Notifications extends NotificationRegistry {
  /**
   * Gets or sets DeclarationEventReceived.
   */
  declarationEventReceived = this.create<RealTimeDecEvent, void>('DeclarationEventReceived')
}